module.exports = __webpack_public_path__ + "static/fonts/NotoSansKR-Black-Hestia.9350b07.otf";